import React, { useImperativeHandle, useRef } from "react";
import { TextArea as TextAreaLib, TextAreaRef } from "@npm_leadtech/qr-ui-components";

import { TextAreaAdapterProps } from "./types";

import { useAdapterLogic } from "./hooks";

export const TextAreaAdapter = React.forwardRef<TextAreaRef, TextAreaAdapterProps>((props, ref) => {
  const internalRef = useRef<TextAreaRef>(null);

  useImperativeHandle(ref, () => internalRef.current as TextAreaRef, []);

  const textAreaProps = useAdapterLogic(props, internalRef);

  return <TextAreaLib {...textAreaProps} />;
});

TextAreaAdapter.displayName = "TextAreaAdapter";
